export default __webpack_public_path__ + "static/media/ic_prize.26161cef.svg";